import styled from 'styled-components';

import { Theme } from '@/shared/themes';

export const Option = styled.div`
  padding: 12px 20px;
  font-size: 18px;
  border-radius: 12px;
  line-height: 140%;

  &.active,
  &:hover {
    background-color: ${({ theme }: { theme: Theme }) => theme.colors.select.selectedOption};
  }
`;
